module.exports = {
  Invalid20: 'ราคาขายตู้ 20\' ต้องไม่ต่ำกว่าต้นทุน',
  Invalid40: 'ราคาขายตู้ 40\' ต้องไม่ต่ำกว่าต้นทุน',
  Invalid45: 'ราคาขายตู้ 45\' ต้องไม่ต่ำกว่าต้นทุน',
  ALL: '【ทั้งหมด】',
  ALLINIncludes: 'ราคา ALL IN รวมค่าธรรมเนียมเพิ่มเติมดังนี้:',
  ALLINRemarks: 'หมายเหตุ: ราคา ALL IN รวมค่าธรรมเนียมที่ไฮไลต์ด้วยพื้นหลังสีเทาแล้ว',
  ALLRG: '【ทั้งหมด】',
  AbnormalDetected: 'เรียนลูกค้า ระบบตรวจพบปัญหาที่อาจเกิดขึ้นกับอัตราค่าขนส่งที่รอตรวจสอบตามกฎการตรวจสอบที่ตั้งไว้ หากต้องการดูรายละเอียด กรุณาคลิกที่หัวข้อสีน้ำเงิน',
  Accept: 'ยอมรับ',
  AcceptTenant: 'ผู้รับ',
  AcceptTime: 'วันที่รับ',
  AcceptUser: 'ผู้รับ',
  Accepted: 'รับแล้ว',
  Add: 'เพิ่มใหม่',
  AddCondition: 'เพิ่มเงื่อนไขการตัดสิน',
  AddFee: 'เพิ่มค่าธรรมเนียม',
  AddNewCustomer: 'เพิ่มลูกค้าใหม่',
  Address: 'ที่อยู่',
  Agent: 'ตัวแทน',
  Agree: 'อนุมัติคำขอ',
  CancelAgree: 'ยกเลิกการอนุมัติ',
  Canceled: 'ยกเลิกแล้ว',
  Agreed: 'อนุมัติแล้ว',
  Air: 'ขนส่งทางอากาศ',
  AirStatistics: 'สถิติอัตราค่าขนส่งทางอากาศ',
  Aircraft: 'รุ่นเครื่องบิน',
  AircraftFullName: 'ชื่อเต็มรุ่นเครื่องบิน',
  Airliner: 'เครื่องบินโดยสาร',
  AlertEQAbnormal: 'แจ้งเตือนเมื่อพบเงื่อนไขต่อไปนี้ในการเปรียบเทียบราคาตู้ประเภทต่าง ๆ ภายใต้เงื่อนไขเดียวกัน',
  AlertPlaceAbnormal: 'แจ้งเตือนเมื่อพบเงื่อนไขต่อไปนี้ในการเปรียบเทียบราคาตู้ประเภทเดียวกันที่ POL และ POD เดียวกัน',
  AlertSumAbnormal: 'แจ้งเตือนเมื่อพบเงื่อนไขต่อไปนี้เกี่ยวกับค่าใช้จ่ายรวมของอัตราค่าขนส่ง',
  AlertValidAbnormal: 'แจ้งเตือนเมื่อพบเงื่อนไขต่อไปนี้เกี่ยวกับอายุอัตราค่าขนส่ง',
  AllState: '【ทั้งหมด】',
  AllowedTier: 'ระดับที่อนุญาตให้ดูคือ',
  Amount: 'ค่าใช้จ่าย',
  Approve: 'ตรวจสอบ',
  ApproveAsync: 'ต้องการรันงานตรวจสอบในพื้นหลังหรือไม่?',
  TariffRatingAtTheTimeOfMaintenance: 'กำหนดระดับอัตราค่าขนส่ง',
  ApproveSet: 'การตั้งค่าการตรวจสอบ',
  ApprovedBy: 'ผู้ตรวจสอบ',
  ApprovedDate: 'วันที่ตรวจสอบ',
  Attachment: 'ไฟล์แนบ',
  Audit: 'ตรวจสอบ',
  AuthAccept: 'ที่ผู้อื่นแชร์',
  AuthInvite: 'แชร์ให้ผู้อื่น',
  AuthInvite2: 'การแชร์อัตราค่าขนส่ง',
  AuthAccept2: 'การสมัครรับอัตราค่าขนส่ง',
  AuthorizedClient: 'หน่วยงานที่มอบหมาย',
  BOTH_EMPTY: '{0} บรรทัด {1} บันทึกอย่างน้อยหนึ่งรายการกับ {2} \n',
  Back: 'กลับ',
  BadDays: 'รูปแบบเส้นทางไม่ถูกต้อง!',
  BasicInfo: 'ข้อมูลพื้นฐาน',
  ECommerceEta: 'เวลามาถึงโดยประมาณ (ETA) สำหรับอีคอมเมิร์ซ',
  ECommerceEtd: 'เวลาออกเดินทางโดยประมาณ (ETD) สำหรับอีคอมเมิร์ซ',
  BasicPort: 'ท่าเรือหลัก',
  BeginDate: 'ระยะเวลาที่มีผล',
  BeginDateCol: 'มีผลตั้งแต่',
  Big: 'เพิ่มขึ้น',
  BillType: 'ประเภทใบตราส่งสินค้า',
  BookingAgent: 'ตัวแทนจองพื้นที่',
  Both: 'ราคาเดียวกันทั้งแบบจ่ายล่วงหน้าและจ่ายปลายทาง',
  Branch: 'สาขา',
  BusinessType: 'ประเภทธุรกิจ',
  ByDate: 'ตามเวลา',
  ByPort: 'ตามท่าเรือ',
  ByState: 'ตามสถานะ',
  CANCEL: 'ยกเลิก',
  CHARGES: '{0} แถว {1} ป้อนข้อมูลค่าธรรมเนียมเพิ่มเติมผิดพลาดด้วยประเภทกล่อง {2} \n',
  COD: 'ประเทศ(ภูมิภาค) ปลายทาง',
  CODPrompt: 'กรุณาป้อนประเทศหรือภูมิภาคที่ขนถ่ายสินค้า',
  CODAirPrompt: 'กรุณาป้อนประเทศหรือภูมิภาคปลายทาง',
  COL: 'ประเทศ(ภูมิภาค) ต้นทาง',
  COLPrompt: 'กรุณาป้อนประเทศหรือภูมิภาคต้นทาง',
  COMMON_ERROR: 'แถวที่ {0}, {1} ไม่ถูกต้อง;<br/>',
  CONFIRM: 'ยืนยัน',
  COST_VAT: 'อัตราภาษีต้นทุน',
  CabinNature: 'ลักษณะของพื้นที่จัดเก็บ',
  CabinState: 'สถานะพื้นที่จัดเก็บ',
  Cancel: 'ยกเลิก',
  CargoAircraft: 'เครื่องบินขนส่งสินค้า',
  Carrier: 'บริษัทเรือ',
  Carrier_Air: 'สายการบิน',
  CasePriceInvalid: 'ราคาขายต่อหน่วยต้องไม่ต่ำกว่าต้นทุน',
  ChargeName: 'ชื่อค่าธรรมเนียม',
  ChargeOfDeliveryPlace: 'ค่าธรรมเนียมสถานที่ส่งมอบ',
  ChargeOfReceiptPlace: 'ค่าธรรมเนียมสถานที่รับสินค้า',
  ChargeType: 'ประเภทค่าธรรมเนียม',
  ChargeUnit: 'หน่วยคิดเงิน',
  ChargedWeight: 'น้ำหนักคิดเงิน',
  Check: 'ตรวจสอบ',
  CheckApproveSet: 'การตั้งค่าการหมดเวลาการตรวจสอบ',
  CheckInterval: 'ช่วงเวลาการวนรอบ',
  ChineseName: 'ชื่อภาษาจีน',
  Chk: '【ช่องทำเครื่องหมาย】',
  City: 'เมือง',
  ClickMe: 'คลิกเพื่อเปลี่ยนโหมดการค้นหา',
  ClickMeSimple: 'คลิกเพื่อเปลี่ยนโหมดการค้นหา\nวิธีการค้นหาแบบง่ายจะมีผลบังคับใช้เริ่มจากวันนี้เป็นค่าเริ่มต้น หากต้องการค้นหาราคาสำหรับระยะเวลาอื่น โปรดใช้การค้นหาระดับสูง',
  Client: 'ลูกค้า',
  ClientExist: 'ชื่อลูกค้ามีอยู่ในระบบแล้ว!',
  ClientIsEmpty: 'หน่วยมอบหมายไม่สามารถเว้นว่างได้',
  ClientName: 'ชื่อลูกค้า',
  Close: 'ปิด',
  ClosingDay: 'วันปิดรับสินค้า',
  Code: 'รหัส',
  Collect: 'เก็บเงินปลายทาง',
  Coloader: 'เพื่อนร่วมงาน',
  ColoaderMin: 'เพื่อนร่วมงาน(ขั้นต่ำ)',
  ColoaderPrice: 'ราคาเพื่อนร่วมงาน',
  ColoaderRate: 'เพื่อนร่วมงาน(อัตรา)',
  ColumnName: 'ชื่อคอลัมน์',
  Commodity: 'สินค้า',
  Common: 'สินค้าทั่วไป',
  CompareTime: 'เวลาเริ่มต้นต้องน้อยกว่าเวลาสิ้นสุด!',
  CompareValidate: 'เวลาสิ้นสุดของอายุการใช้งานต้องมากกว่าเวลาเริ่มต้น!',
  FreeTimeType: 'ประเภทระยะเวลาปล่อยตู้ฟรี',
  PleaseInput: 'กรุณาใส่ค่าของ {0}',
  NeedFreeBox: 'ใช้ตู้ฟรี {0} วันแบบผสม',
  FreeTimeCalculatedSeparately: 'ระยะเวลาปล่อยสินค้าฟรี {0} วัน, ใช้ตู้ฟรี {1} วัน',
  Contact: 'ผู้ติดต่อ',
  ContinueApprove: 'ดำเนินการตรวจสอบต่อ',
  ContractNo: 'เลขที่สัญญา',
  Copy: 'คัดลอก',
  CopyPriceNo: 'คัดลอกเลขที่เอกสาร',
  CopyQuotation: 'คัดลอกใบเสนอราคา',
  CopySetting: 'คัดลอกการตั้งค่า',
  Cost: 'ต้นทุน',
  Cost20: 'ต้นทุน 20\'',
  Cost40: 'ต้นทุน 40\'',
  Cost45: 'ต้นทุน 45\'',
  CostHC: 'ต้นทุน 40\'HC',
  CostMin: 'ต้นทุน(ขั้นต่ำ)',
  CostPrice: 'ราคาต้นทุน',
  CostRate: 'ต้นทุน(อัตรา)',
  Country: 'ประเทศ',
  CountryPrompt: 'กรุณาใส่ประเทศหรือภูมิภาคต้นทาง',
  CreatedBy: 'ผู้บันทึกข้อมูล',
  CreatedDate: 'วันที่สร้าง',
  Currency: 'สกุลเงิน',
  CurrentPrice: 'เผยแพร่แล้ว',
  CurrentPriceEditSucceed: 'การแก้ไขอัตราค่าขนส่งที่เผยแพร่แล้วสำเร็จ สถานะจะเปลี่ยนเป็นอัตราค่าขนส่งรอตรวจสอบโดยอัตโนมัติ คุณต้องอนุมัติใหม่',
  CurrentTenant: 'บริษัทของเรา',
  CustomConfig: 'กำหนดเอง...',
  CustomerMin: 'ลูกค้าโดยตรง(ขั้นต่ำ)',
  CustomerPrice: 'ราคาลูกค้าโดยตรง',
  CustomerRate: 'ลูกค้าโดยตรง(อัตรา)',
  CyCy: 'CY-CY',
  CyDoor: 'CY-DOOR',
  CyRamp: 'CY-RAMP',
  Dangerous: 'สินค้าอันตราย',
  DangerousClass: 'ระดับสินค้าอันตราย',
  DataGridConfig: 'กำหนดคอลัมน์ที่แสดงเอง',
  Day: 'วัน',
  Days: 'ระยะทางเดินเรือ',
  DaysColSea: 'ระยะทางเดินเรือ (วัน)',
  DaysUnitSea: 'ระยะทางเดินเรือ (วัน)',
  DaysValidate: 'ระยะทางเดินเรือไม่สามารถเว้นว่างได้',
  DecodeMarkupFailed: 'การวิเคราะห์การตั้งค่าการตรวจสอบอัตราค่าขนส่งล้มเหลว!',
  DelFee: 'ลบค่าธรรมเนียมเพิ่มเติมนี้',
  DelRate: 'ลบอัตราค่าขนส่ง',
  Delete: 'ลบ',
  DeleteCfg: 'ลบรายการการตั้งค่านี้',
  DepartureDay: 'ตารางเรือ',
  DepartureDay2: 'ตารางเรือ 2',
  DepartureDayOfAir: 'ตารางบิน',
  DepartureDayOfAir2: 'ตารางบินเที่ยวที่สอง',
  CargoAircraft2: 'เครื่องบินขนส่งเที่ยวที่สอง',
  AircraftOrFreighter: 'เครื่องบินโดยสาร/เครื่องบินขนส่ง',
  FreighterOrAircraft: 'เครื่องบินขนส่ง/เครื่องบินโดยสาร',
  AirlinerNB: 'เครื่องบินโดยสาร (NB)',
  DesCharge: 'ค่าธรรมเนียมปลายทาง',
  Dest: 'ท่าขนถ่ายสินค้า',
  DestinationDock: 'ท่าเรือปลายทางที่แวะ',
  Detail: '【รายละเอียด】',
  DetailOfFCL: 'รายละเอียดอัตราค่าขนส่งแบบเต็มตู้',
  DetailOfLCL: 'รายละเอียดอัตราค่าขนส่งแบบรวมตู้',
  Details: 'รายละเอียด',
  DifferentCarrier: 'อัตราค่าขนส่งที่ตรวจสอบเป็นของหลายบริษัทเรือ ต้องการดำเนินการต่อหรือไม่?',
  DifferentCarrierAndRegion: 'อัตราค่าขนส่งที่ตรวจสอบเป็นของหลายบริษัทเรือและ{0} ต้องการดำเนินการต่อหรือไม่?',
  DifferentCarrierAndRegions: 'อัตราค่าขนส่งที่ตรวจสอบเป็นของหลายบริษัทเรือ พื้นที่เริ่มต้นและพื้นที่ขนถ่าย ต้องการดำเนินการต่อหรือไม่?',
  DifferentPOD: 'ท่าขนถ่ายสินค้าของราคาที่เลือกไม่เหมือนกันทั้งหมด ต้องการดำเนินการต่อหรือไม่?',
  DifferentPOL: 'ท่าเรือเริ่มต้นของราคาที่เลือกไม่เหมือนกันทั้งหมด ต้องการดำเนินการต่อหรือไม่?',
  DifferentRegion: 'อัตราค่าขนส่งที่ตรวจสอบเป็นของหลาย{0} ต้องการดำเนินการต่อหรือไม่?',
  Direct: 'ตรง',
  DirectCustomer: 'ลูกค้าโดยตรง',
  Dock: 'ท่าเรือที่แวะ',
  Dockland: 'เขตท่าเรือ',
  DocumentCategory: 'ประเภทเอกสาร',
  DocumentId: 'นำเข้าหมายเลขเอกสารต้นทาง',
  DuplicateFees: 'ค่าธรรมเนียมเพิ่มเติม{0} ซ้ำ!',
  DuplicateShare: 'คุณได้แบ่งปันอัตราค่าขนส่งให้{0} แล้ว ไม่จำเป็นต้องดำเนินการซ้ำ',
  EMPTY_DATATABLE: 'เซิร์ฟเวอร์ไม่มีข้อมูลที่เกี่ยวข้องกับ {0} โปรดติดต่อผู้ดูแลระบบ \n',
  EQAbnormal: 'การเปรียบเทียบราคาตู้ประเภทต่างภายใต้เงื่อนไขเดียวกันมีความผิดปกติ',
  EQMustDifferent: 'ประเภทตู้ไม่สามารถเหมือนกันได้',
  EQ_TYPE_SIZE: 'แถวไม่ถูกต้องกับชนิดกล่อง {1} ที่ระบุเป็น {0} \n',
  EXISTS_SAME_TIME: 'แถว {0} {1} และ {2} ไม่สามารถป้อนพร้อมกันได้ \n',
  EXISTS_SAME_TIME2: 'ไม่สามารถป้อน{0} และ{1} พร้อมกันได้',
  Edit: 'แก้ไข',
  EffectiveDate: 'วันที่มีผล',
  EffectiveDateType: 'ประเภทวันที่มีผล',
  Email: 'อีเมล',
  EndDate: 'ถึง',
  EndDateAlign: 'ขวา',
  EndDateCol: 'วันหมดอายุ',
  EndTime: 'เวลาสิ้นสุด',
  EnglishName: 'ชื่อภาษาอังกฤษ',
  EqSize: 'ประเภทตู้คอนเทนเนอร์',
  EqType: 'ชนิดตู้คอนเทนเนอร์',
  Error: 'ข้อผิดพลาด',
  ErrorCfg: 'การตั้งค่ามีข้อผิดพลาด โปรดตรวจสอบ',
  ErrorRaised: 'เกิดข้อผิดพลาด',
  ExceedMaxAmount: 'เมื่อโปรแกรมไม่ทำงานในพื้นหลัง สามารถตรวจสอบได้สูงสุดครั้งละ 300 ข้อมูล',
  ExistLoop: 'มีการตั้งค่าแบบวนซ้ำ',
  ExpirationDate: 'วันที่หมดอายุ',
  ExpirationDateType: 'ประเภทวันที่หมดอายุ',
  Export: 'ส่งออก Excel',
  ExportByTemplate: 'ส่งออกตามเทมเพลต',
  ExportMode: 'โปรดเลือกวิธีการส่งออกข้อมูลอัตราค่าขนส่ง',
  ExportPDF: 'ส่งออก PDF',
  ExtraInfo: 'ข้อมูลเพิ่มเติม',
  ExtraLoadFailed: 'โหลดข้อมูลเพิ่มเติมล้มเหลว!',
  FCL: 'ตู้เต็ม',
  FCLStatistics: 'สถิติอัตราค่าขนส่งตู้เต็ม',
  FIELD_TOO_LONG: '{0} แถว, {1} ยาวเกินไป, ความยาวสูงสุดที่อนุญาตคือ {2}; \n',
  FORMAT_NOT_MATCHING: 'บรรทัด {0} รูปแบบ {1} ไม่ถูกต้อง \n',
  Fair: 'ทรงตัว',
  Fall: 'ลดลง',
  FaultCode: 'รหัสข้อผิดพลาด:',
  FaultMessage: 'ข้อมูล:',
  Fax: 'แฟกซ์',
  FeeFclPrompt: 'โปรดป้อนชื่อย่อของค่าใช้จ่าย',
  FeeIndex: 'หมายเลขลำดับ',
  FeeMin: 'ค่าใช้จ่าย(Min)',
  FeeName: 'ชื่อค่าใช้จ่าย',
  FeeNameIsNull: 'โปรดป้อนชื่อค่าใช้จ่าย',
  FeeRate: 'ค่าใช้จ่าย(Rate)',
  FeeUnit: 'หน่วยคิดเงิน',
  FeeUnitIsNull: 'โปรดป้อนหน่วยคิดเงิน',
  Fees: 'ค่าใช้จ่าย',
  FileHistory: 'ประวัติไฟล์',
  FileName: 'ชื่อเอกสาร',
  FileSize: 'ขนาดเอกสาร',
  Find: 'ค้นหา',
  Finished: 'ดำเนินการเสร็จสิ้น',
  Flight: 'รายการบริการ',
  FreeTime: 'ระยะเวลาปล่อยตู้ฟรี',
  FreightTerm: 'ข้อกำหนดการขนส่ง',
  Fri: 'วันศุกร์',
  Friday: 'วันศุกร์',
  GenerateCharge: 'สร้างค่าใช้จ่ายเมื่อจองตู้',
  Goods: 'ชื่อสินค้า',
  GoodsLevel: 'ระดับ',
  GreaterThanZero: 'ค่าต้องมากกว่า 0!',
  GroupNo: 'หมายเลขกลุ่มที่สังกัด',
  HCInvalid: 'ราคาขาย 40\'HC ต้องไม่ต่ำกว่าต้นทุน',
  HasApproved: 'ตรวจสอบแล้ว',
  HasDeleted: 'ลบแล้ว',
  Hazard: 'สินค้าอันตราย',
  HeadLiftAircraft: 'เที่ยวบินแรก',
  HiddenCost: 'ไม่สามารถดูต้นทุนของสาขาอื่นได้',
  Hour: 'ชั่วโมง',
  Hours: 'ชั่วโมง',
  IS_EMPTY: 'แถว {0} {1} ไม่สามารถว่างได้ \n',
  EXIST_THE_SAME_TIME: 'แถว {0} จำนวน {1} และ {2} แตกต่างกัน \n',
  IS_LESS: 'แถว {0} {1} ต้องไม่น้อยกว่า {2}; \n',
  IS_SAME: 'แถว {0} {1} ไม่เหมือนกับ {2} \n',
  IWantShare: 'ฉันต้องการแบ่งปันอัตราค่าขนส่งให้',
  Import: 'นำเข้า Excel',
  GeekYumImport: 'นำเข้าราคาขนส่ง Jiyu',
  OneStackImport: 'นำเข้าราคาขนส่ง Yida',
  InactiveRate: 'ราคาที่มีเส้นขีดฆ่าในหมายเลขเอกสารถือว่าไม่ใช้งานแล้ว!',
  InputValue: 'กรุณากรอก!',
  Invalid: 'หมดอายุ',
  InvalidSelection: 'ตั้งค่าข้อมูลที่เลือกให้เป็นสถานะไม่ใช้งาน?',
  InviteTenant: 'ผู้เชิญ',
  InviteUser: 'ผู้เชิญ',
  IsActive: 'เปิดใช้งานหรือไม่',
  IsAllowedOperate: 'คุณไม่มีสิทธิ์ตรวจสอบหรือลบอัตราค่าขนส่งจากท่าเรือต้นทาง {0} ถึงท่าเรือปลายทาง {1}!',
  IsAllowedOperate_DiffBranch: 'คุณไม่สามารถแก้ไขอัตราค่าขนส่งที่สาขาอื่นป้อนเข้ามาได้!',
  IsApproveRecord: 'ต้องการตรวจสอบข้อมูลที่เลือกหรือไม่?',
  IsApproveRecords: 'ต้องการตรวจสอบข้อมูลที่เลือกหรือไม่?',
  IsBooked: 'ต้องการสร้างใบสั่งซื้อหรือไม่',
  IsCopy: 'คุณต้องการคัดลอกใบเสนอราคาที่เลือกไว้หรือไม่?',
  IsDeleteRecord: 'ต้องการลบข้อมูลที่เลือกหรือไม่?',
  IsDeleteRecords: 'ต้องการลบข้อมูลที่เลือกหรือไม่?',
  IsMarkup: 'คุณต้องการเพิ่มราคาจริงหรือ?',
  KPIEmail: 'ผู้รับรายงานประเมิน KPI',
  LCL: 'รวมตู้',
  Lane: 'รหัสเส้นทาง',
  LatestTemplateVersion: 'เวอร์ชันล่าสุดของเทมเพลตคือ {0}',
  Level: 'ระดับ',
  LoadSucceed: 'นำเข้าระบบเรียบร้อยแล้ว! \n',
  LocalCharge: 'ค่าใช้จ่ายท้องถิ่น',
  MUST_EMPTY: 'แถว {0} ตามค่าของ {2} {1} จะต้องว่างเปล่า \n',
  ManualAudit: 'ตรวจสอบการเพิ่มราคาแบบมือ',
  ECommerceFareOfflineReminder: 'แจ้งเตือนการยกเลิกอัตราค่าขนส่งอีคอมเมิร์ซที่เผยแพร่แล้ว',
  ECommerceFareOfflineReminderContent: 'เมื่ออัตราค่าขนส่งอีคอมเมิร์ซของบริษัทเรือที่เกี่ยวข้องผ่านการอนุมัติ อัตราที่เผยแพร่ก่อนหน้าจะถูกยกเลิก และอัตราที่อนุมัติในครั้งนี้จะเป็นอัตราอีคอมเมิร์ซเพียงหนึ่งเดียวที่บริษัทเรือนั้นเผยแพร่',
  PleaseSelectDataForTheSameTariffType: 'กรุณาเลือกข้อมูลประเภทอัตราค่าขนส่งเดียวกัน',
  MarketPrice: 'ราคาตลาด',
  Markup: 'เพิ่มราคา',
  MarkupBy: 'เพิ่มราคาตามช่วง',
  MarkupRate: 'เพิ่มราคาแบบความสามัคคี',
  MarkupTo: 'เพิ่มราคาเป็น',
  MarkupType: 'ประเภทการเพิ่มราคา',
  MaxMailPerDay: 'แจ้งเตือนทางอีเมลสูงสุดต่อวัน',
  MaxQueryCount: 'แสดงข้อมูลบางส่วนเท่านั้น โปรดเพิ่มเงื่อนไขการกรอง!',
  MaxQueryCount2: 'ดึงข้อมูลเพียง {0} รายการแรก กรุณาคลิกปุ่ม \'ดู\' เพื่อสิ้นสุดการค้นหาหรือคลิก \'เพิ่มเติม\' เพื่อค้นหาต่อ สูงสุด 10,000 รายการ โปรดจำกัดขอบเขตการค้นหา',
  Measurement: 'ขนาด',
  MinCharge: 'ขั้นต่ำ',
  MinimumInvalidLCL: 'ราคาต่ำสุดต้องไม่สูงกว่าราคาตามน้ำหนักหรือปริมาตร',
  MinimumPrice: 'ราคาต่ำสุด',
  ModifiedBy: 'ผู้แก้ไข',
  ModifiedDate: 'วันที่แก้ไข',
  Mon: 'วันจันทร์',
  Monday: 'วันจันทร์',
  Month: 'เดือน',
  MoreSetting: 'การตั้งค่าขั้นสูง',
  MustDifferent: '{0} และ {1} ห้ามเหมือนกัน!',
  NA: 'ไม่มีข้อมูล',
  NOT_ALLOWED_NEGATIVE: 'แถว {0} {1} ต้องไม่น้อยกว่า 0; \n',
  NOT_ALLOWED_UPLOAD: 'ไม่อนุญาตให้อัพโหลดค่าจัดส่ง {0} \n',
  NO_CONFIGURATION_CHARGES: 'เซิร์ฟเวอร์ไม่มีการกำหนดค่าเพิ่มเติม {0} โปรดติดต่อผู้ดูแลระบบ \n',
  NO_FIELD: '{0} หายไปในตาราง; \n',
  NO_OF: 'แถว {0} ตารางขาด OF; \# n ที่มีประเภทกล่อง {1}',
  NO_SUM: '{0} แถว, SUM ที่มีชนิดกล่อง {1} เป็นสิ่งจำเป็น; \n',
  NStep: 'ระดับ N',
  NaCode: 'เอ็นเอซี',
  NeedCheckApproveCfg: '0: ระบบไม่ตรวจสอบว่ามีอัตราใหม่ที่ยังไม่อนุมัติ 1: ระบบตรวจสอบอัตโนมัติ',
  NeedCheckValidityCfg: '0: ไม่ตรวจสอบความถูกต้องก่อนอนุมัติ 1: ตรวจสอบความถูกต้องก่อนอนุมัติ',
  NeedMarkupCfg: '0: ไม่แบ่งเลเยอร์หลังอนุมัติ 1: สร้างอัตราหลายเลเยอร์หลังอนุมัติ',
  NetConnectionFailed: 'ระบบไม่ได้เชื่อมต่อกับเซิร์ฟเวอร์ การส่งคำขอล้มเหลว',
  NewRate: 'เพิ่มอัตราค่าขนส่ง',
  Next: 'ขั้นตอนต่อไป',
  No: 'ไม่',
  NoChargeAndPrice: 'กรุณากรอกข้อมูลราคาหรือค่าธรรมเนียม',
  NoExchangeRate: 'ระบบไม่ได้บำรุงรักษาอัตราแลกเปลี่ยน {0}',
  NoHit: 'ไม่พบรายการที่ตรงกัน!',
  NoLabel: 'เพิ่มเติม',
  NoPODCharge: 'ไม่มีข้อมูลค่าธรรมเนียมท่าเรือปลายทาง!',
  NoRecord: 'ไม่มีข้อมูล',
  TariffTableExportLevelTitleTips: 'คำเตือนการส่งออกตารางอัตราค่าขนส่ง',
  TariffTableExportLevelTips: 'กำลังส่งออกอัตราค่าขนส่ง [ระดับอัตรา: {0}]',
  PleaseSelectTheExpirationDateFirst: 'กรุณาเลือกระยะเวลามีผลก่อน',
  EitherETDOrValidityPeriodMustBeFilledIn: 'ต้องกรอก ETD หรือระยะเวลามีผลอย่างใดอย่างหนึ่ง',
  theSelectedValidityPeriodCannotExceed3Months: 'ระยะเวลามีผลที่เลือกต้องไม่เกิน 3 เดือน',
  theSelectedETDCannotExceed3Months: 'ช่วงเวลา ETD ที่เลือกต้องไม่เกิน 3 เดือน',
  NoRecordSelect: 'ไม่ได้เลือกข้อมูล!',
  NoRecordUpload: 'ไม่พบอัตราค่าขนส่งในตารางที่สามารถอัปโหลดได้!',
  NoSetting: 'กรุณาไปที่หน้าการตั้งค่าเพื่อเพิ่มการกำหนดค่า PFMarkupSetting',
  NoSettingSelect: 'กรุณาเลือกตัวเลือกการกำหนดค่า!',
  NoSurcharge: 'ไม่พบค่าธรรมเนียม {0}',
  NoTax: 'ราคาทั้งหมดไม่รวมภาษี อัตราภาษีที่แท้จริงจะขึ้นอยู่กับผู้ขนส่งเป็นผู้กำหนดในขั้นสุดท้าย',
  NoTierChange: 'ระดับอัตราค่าขนส่งไม่มีการเปลี่ยนแปลง',
  NotAccepted: 'รอการยอมรับ',
  NotAllowed: 'คุณไม่สามารถเข้าถึงอัตราค่าขนส่งระดับนี้ได้',
  NotAllowedCopy: 'คุณไม่สามารถคัดลอกใบเสนอราคาของผู้อื่นได้',
  NotAllowedDelete: 'คุณไม่สามารถลบอัตราค่าขนส่งที่ผู้ใช้อื่นป้อนเข้ามาได้!',
  NotAllowedDifferentCarrierAndRegion: 'อัตราค่าขนส่งมีหลายบริษัทเรือและ{0} ไม่อนุญาตให้ตรวจสอบ!',
  NotAllowedDifferentCarrierAndRegions: 'อัตราค่าขนส่งมีหลายบริษัทเรือ พื้นที่เริ่มต้นและพื้นที่ขนถ่าย ไม่อนุญาตให้ตรวจสอบ!',
  NotAllowedDifferentRegions: 'อัตราค่าขนส่งมีหลาย{0} ไม่อนุญาตให้ตรวจสอบ!',
  NotAllowedFromCountry: 'คุณไม่สามารถดูอัตราค่าขนส่งที่ท่าเรือต้นทางในประเทศนี้ได้!',
  NotAllowedFromRegion: 'คุณไม่สามารถดูอัตราค่าขนส่งที่ท่าเรือต้นทางในภูมิภาคนี้ได้!',
  NotAllowedInput: 'คุณไม่มีสิทธิ์เพิ่มท่าเรือต้นทางนี้',
  NotAllowedPOD: 'คุณไม่สามารถดูอัตราค่าขนส่งที่ท่าเรือปลายทางนี้ได้!',
  NotAllowedPOL: 'คุณไม่สามารถดูอัตราค่าขนส่งที่ท่าเรือต้นทางนี้ได้!',
  NotAllowedPOD2: 'คุณไม่สามารถดูอัตราค่าขนส่งที่ท่าเรือปลายทาง({0})ได้!',
  NotAllowedPOL2: 'คุณไม่สามารถดูอัตราค่าขนส่งที่ท่าเรือต้นทาง({0})ได้!',
  NotAllowedToCountry: 'คุณไม่สามารถดูอัตราค่าขนส่งที่ท่าเรือปลายทางในประเทศนี้ได้!',
  NotAllowedToRegion: 'คุณไม่สามารถดูอัตราค่าขนส่งที่ท่าเรือปลายทางในภูมิภาคนี้ได้!',
  NotAuth: 'คุณไม่มีสิทธิ์เพียงพอ',
  NotCheck: 'รอการตรวจสอบ',
  NotQuotationToOthers: 'กรุณาอย่าเสนอราคาให้กับลูกค้าของพนักงานขายคนอื่น',
  NotRequired: 'ไม่ตั้งค่า',
  NotSameLength: '{0} และ {1} จำนวนไม่เท่ากัน',
  NotSave: 'การดำเนินการของคุณยังไม่ถูกบันทึก ต้องการบันทึกการเปลี่ยนแปลงหรือไม่?',
  Num: 'จำนวน',
  Num20: 'จำนวนตู้ 20 ฟุต',
  Num40: 'จำนวนตู้ 40 ฟุต',
  Num45: 'จำนวนตู้ 45 ฟุต',
  NumHC: 'จำนวนตู้ 40 ฟุต HC',
  OK: 'ยืนยัน',
  Origin: 'ท่าเรือต้นทาง',
  OtherInfo: 'ข้อมูลอื่นๆ',
  FreeContainerPeriod: 'ระยะเวลาปลอดค่าตู้',
  OvertimeApprove: 'เตือนเกินเวลา',
  Owner: 'พนักงานขายที่รับผิดชอบ',
  POD: 'ท่าเรือปลายทาง',
  PODCharge: 'ค่าบริการท่าเรือปลายทาง',
  PODCity: 'เมืองปลายทาง',
  PODCityPrompt: 'กรุณาใส่เมืองปลายทาง',
  PODCodeChanged: 'รหัสท่าเรือขนถ่ายไม่ตรงกับข้อมูลในระบบ อัตราค่าขนส่งนี้อาจใช้การไม่ได้แล้ว!',
  PODCountry: 'ประเทศ(ภูมิภาค)ของท่าเรือปลายทาง',
  PODIsNull: 'กรุณาใส่ท่าเรือขนถ่าย!',
  PODPrompt: 'กรุณาใส่ท่าเรือขนถ่าย',
  PODs: 'หลายท่าเรือปลายทาง',
  POL: 'ท่าเรือต้นทาง',
  POLCity: 'เมืองต้นทาง',
  POLCityPrompt: 'กรุณาใส่เมืองต้นทาง',
  POLIsNull: 'กรุณาใส่ท่าเรือต้นทาง!',
  POLPrompt: 'กรุณาใส่ท่าเรือต้นทาง',
  PODPrompt2: 'กรุณาใส่ท่าเรือปลายทาง',
  POLs: 'หลายท่าเรือต้นทาง',
  PasteQuotation: 'ติดใบเสนอราคา',
  PasteSetting: 'การตั้งค่าการติดตั้ง',
  PaymentTerm: 'เงื่อนไขการชำระเงิน',
  PendingPrice: 'รอการตรวจสอบ',
  Phone: 'โทรศัพท์',
  PlaceAbnormal: 'พบความผิดปกติในการเปรียบเทียบราคาของ POL และ POD ที่มีตู้คอนเทนเนอร์แบบเดียวกัน',
  PlaceOfDelivery: 'สถานที่ส่งมอบ',
  PlaceOfReceipt: 'สถานที่รับสินค้า',
  PleaseSelectBookingAgent: 'กรุณาเลือกตัวแทน',
  PlsChangeSystemCfg: 'กรุณาแก้ไขการตั้งค่าเริ่มต้นในหน้าตั้งค่าระบบ และเปิดใช้งานการตั้งค่าที่ต้องการ',
  PlsConfigDetail: 'กรุณาตั้งค่าเงื่อนไขการสมัครสมาชิกอย่างละเอียด!',
  PlsInput: 'กรุณากรอก {0}',
  PlsInputClient: 'กรุณากรอกข้อมูลลูกค้า',
  PlsInputCode: 'กรุณากรอกชื่อเต็มบริษัทหรือรหัสของผู้รับ!',
  PlsInputPOLPOD: 'กรุณากรอกท่าเรือต้นทางและท่าเรือปลายทางในหน้า \'ข้อมูลพื้นฐาน\'!',
  PlsInputPersonalInfo: 'ข้อมูลผู้ติดต่อและเบอร์โทรศัพท์ของลูกค้าไม่สามารถเว้นว่างได้!',
  PlsInputQuotationNo: 'กรุณากรอกหมายเลขใบเสนอราคา',
  PlsInputRemark: 'กรอกข้อมูลหมายเหตุ',
  PlsInputUserInfo: 'กรุณากรอกข้อมูลส่วนตัวให้ครบถ้วน',
  PlsSelect: 'กรุณาเลือก',
  PlsSelectOF: 'กรุณาเลือกข้อมูลอัตราค่าขนส่งหนึ่งรายการเป็นค่าขนส่งทางทะเล',
  PlsSelectOffice: 'กรุณาเลือกบริษัท (สาขา) ที่ต้องการสมัครสมาชิก:',
  PlsSelectRecord: 'กรุณาเลือกรายการ!',
  PlsSelectRejectEQ: 'กรุณาเลือกรูปแบบตู้คอนเทนเนอร์ที่ปฏิเสธ',
  PlsSelectRule: 'กรุณาเลือกกฎการเพิ่มราคาหนึ่งรายการ!',
  PlsSelectTenant: 'กรุณาเลือกพันธมิตรที่ต้องการสมัครสมาชิก:',
  PlsSelectValue: 'กรุณาเลือก!',
  PlsSetEmail: 'ตั้งค่าอีเมลที่ต้องการรับข้อมูลการสมัครสมาชิก:',
  PlsSubscribe: 'กรุณาสมัครสมาชิกข้อมูลที่คุณสนใจ เมื่ออัตราค่าขนส่งมีการอัปเดต คุณจะได้รับอีเมลแจ้งเตือน',
  PodRegion: 'พื้นที่ท่าเรือปลายทาง',
  Port: 'ท่าเรือ',
  PortPrompt: 'กรุณากรอกท่าเรือ',
  Prepaid: 'ชำระล่วงหน้า',
  PriceDateType: 'เกณฑ์อายุความ',
  volumeWeightRatio: 'อัตราส่วนปริมาตรต่อน้ำหนัก',
  minRateValue: 'หน่วยคิดค่าบริการขั้นต่ำ',
  PleaseNumber: 'กรุณากรอกตัวเลข',
  F: 'อายุความนับจากวันที่สินค้าขึ้นเรือลากจูง',
  M: 'อายุความนับจากวันที่สินค้าขึ้นเรือแม่',
  PriceInfo: 'ข้อมูลอัตราค่าขนส่ง',
  PriceLoadFailed: 'ไม่สามารถโหลดอัตราค่าขนส่งได้ตามปกติ!',
  PriceNo: 'หมายเลขอัตราค่าขนส่ง',
  PriceNoIsNull: 'กรุณากรอกหมายเลขใบอัตราค่าขนส่ง!',
  PriceNoPrompt: 'กรุณากรอกหมายเลขใบอัตราค่าขนส่งหรือ 7 หลักท้าย',
  PriceSetting: 'การตั้งค่าอัตราค่าขนส่ง',
  PriceState: 'สถานะอัตราค่าขนส่ง',
  PriceState_Common: 'ปกติ',
  PriceState_Inquiry: 'สอบถามราคา',
  PriceState_Lack: 'ตึงเครียด',
  PriceState_Overbooked: 'สินค้าเต็ม',
  PriceState_Reject: 'ไม่รับ',
  PriceState_Suspend: 'หยุดเดินเรือ',
  PriceTrend: 'แนวโน้มราคา',
  Print: 'พิมพ์',
  Query: 'ค้นหา',
  QueryRecords: 'พบ {0} รายการ',
  Quotation: 'เสนอราคา',
  QuotationClient: 'ลูกค้าชั่วคราว',
  QuotationDate: 'เวลาที่เสนอราคา',
  QuotationNo: 'เลขที่ใบเสนอราคา',
  QuotationValidFrom: 'อายุของใบเสนอราคา',
  RATE_TYPE_ERROR: '{0} แถว {1} ไม่ถูกต้องไฟล์ Excel ที่อัปโหลดแตกต่างจากประเภทการจัดส่งหน้าปัจจุบันหรือราคาจัดส่ง Excel ที่อัปโหลดในปัจจุบันไม่ใช่เทมเพลตล่าสุด \n',
  REGION_NO_POD: 'แถว {0} พื้นที่ที่ POD เป็นของ {1} ไม่ตรงกับพื้นที่ขนถ่าย (ROD) ในตาราง \n',
  REGION_NO_POL: 'แถว {0} พื้นที่ของ POL คือ {1} ไม่ตรงกับพื้นที่จัดส่ง (ROL) ในตาราง \n',
  ROD: 'พื้นที่ปลายทาง',
  ROD_EQ: 'พื้นที่ขนถ่ายสินค้าหรือประเภทตู้',
  ROL: 'พื้นที่เริ่มต้นขนส่ง',
  Rate: 'อัตราค่า',
  RateByCost: 'อัตราต้นทุน',
  RateDetails: 'รายละเอียดค่าขนส่ง',
  RateGrade: 'ระดับอัตราค่าขนส่ง',
  RateValidation: 'การตรวจสอบความถูกต้องของอัตราค่าขนส่ง',
  ReallyWantAccept: 'คุณแน่ใจหรือไม่ที่จะยอมรับอัตราค่าขนส่งที่ {0} แบ่งปัน?',
  ReallyWantAgree: 'คุณแน่ใจหรือไม่ที่จะอนุมัติอัตราค่าขนส่งที่ {0} ขอ?',
  ReallyWantCancelAccept: 'คุณแน่ใจหรือไม่ที่จะยกเลิกการดูอัตราค่าขนส่งที่ {0} แบ่งปัน?',
  ReallyWantCancelShare: 'คุณแน่ใจหรือไม่ที่จะไม่แบ่งปันอัตราค่าขนส่งให้ {0} อีก?',
  ReallyWantChange: 'คุณแน่ใจหรือไม่ที่จะปรับระดับอัตราค่าขนส่งเป็น {0}?',
  ReallyWantRefuse: 'คุณแน่ใจหรือไม่ที่จะปฏิเสธอัตราค่าขนส่งที่ {0} ขอ?',
  ReallyWantShare: 'คุณแน่ใจหรือไม่ที่จะแบ่งปันอัตราค่าขนส่งให้ {0}?',
  ReceivingInstructions: 'คำอธิบายพิเศษการรับสินค้า',
  ReceivingType: 'ประเภทคำอธิบายพิเศษการรับสินค้า',
  Records: 'ตาราง {0} มี {1} รายการ',
  Refresh: 'รีเฟรช',
  RefreshFinished: 'รีเฟรชเสร็จสิ้น',
  Refuse: 'ปฏิเสธคำขอ',
  RefuseRemark: 'เหตุผลการปฏิเสธ',
  Refused: 'ปฏิเสธแล้ว',
  Region: 'พื้นที่',
  RegionOrCarrier: 'พื้นที่หรือบริษัทเรือ',
  RejectRate: 'ราคาที่มีเส้นขีดอยู่ในสถานะปฏิเสธ โปรดระวัง!',
  RemarkAreaToolTip: 'ดับเบิลคลิกเพื่อขยาย ดับเบิลคลิกอีกครั้งเพื่อย่อกลับ',
  Remarks: 'หมายเหตุ',
  ECommerceRemarks: 'หมายเหตุราคาอีคอมเมิร์ซ',
  TraditionalRemarks: 'หมายเหตุราคาออฟไลน์',
  RemoteBooking: 'สร้างงานใหม่',
  Reset: 'รีเซ็ต',
  Rise: 'เพิ่มขึ้น',
  Route: 'พื้นที่',
  RouteAndPODEmpty: 'เส้นทางเดินเรือและท่าเรือขนถ่ายสินค้าไม่สามารถว่างพร้อมกันได้!',
  RouteAndPODEmpty1: 'กรุณาระบุข้อมูลอย่างน้อย 1 รายการจากท่าเรือต้นทาง ท่าเรือปลายทาง เส้นทางเดินเรือ บริษัทเรือ (สายการบิน) หรือตัวแทนจัดเรือ (แหล่งที่มาของอัตราค่าขนส่ง)',
  RouteAndPODEmpty2: 'กรุณาระบุข้อมูลอย่างน้อย 1 รายการจากท่าเรือต้นทาง ท่าเรือปลายทาง หรือเส้นทางเดินเรือ',
  SELL_VAT: 'อัตราภาษีราคาขาย',
  SUM_NOT_EQUAL: '{0} แถว ยอดรวมของค่าธรรมเนียมกล่อง {1} จะไม่เท่ากับยอดรวมของค่าธรรมเนียมเพิ่มเติมแต่ละรายการ \n',
  SaleState: 'สถานะราคาพิเศษ',
  Sales: 'ขาย',
  Sat: 'วันเสาร์',
  Saturday: 'วันเสาร์',
  Save: 'บันทึก',
  SaveQuotation: 'กรุณาบันทึกใบเสนอราคาก่อน!',
  SavedSucceed: 'บันทึกเรียบร้อยแล้ว',
  ApplyAgree: 'อนุมัติการตรวจสอบมีผลบังคับใช้',
  ApplyRefuse: 'ปฏิเสธการตรวจสอบมีผลบังคับใช้',
  CancelAgreed: 'ยกเลิกการอนุมัติมีผลบังคับใช้',
  ScheduleDetails: 'ตารางเรือ',
  ScheduleInfo: 'ข้อมูลตารางเรือ',
  SchemeAudit: 'การตรวจสอบการเพิ่มราคาแผน',
  Search: 'ค้นหา:',
  SelectRoute: 'กรุณาเลือกพื้นที่!',
  SelectTerm: 'กรุณาเลือกเงื่อนไขการชำระเงิน!',
  SelectTransportMode: 'กรุณาเลือกวิธีการขนส่ง!',
  Self: 'ดำเนินการเอง',
  Sell: 'ราคาขาย',
  ServiceCode: 'รหัสบริการ',
  ServiceMode: 'โหมดบริการ',
  Setting: 'ตั้งค่า',
  SettingDuplicate: 'ตั้งค่าซ้ำ',
  SettingNoEQ: 'แถวที่เลือกไว้ขาดประเภทตู้!',
  SettingNoRegion: 'แถวที่เลือกไว้ขาด {0}!',
  SettingOverlap: 'มีการตั้งค่าซ้ำในสองแถวที่เลือกไว้!',
  Share: 'ร่วมระวาง',
  ShareCarriers: 'บริษัทเรือร่วมระวาง',
  ShareRemark: 'คำอธิบายการแบ่งปัน',
  ShareRemarks: '※คำอธิบายการแบ่งปันสามารถเห็นได้ทั้งสองฝ่าย',
  ShareState: 'สถานะ',
  ShareToPrompt: 'กรุณากรอกผู้รับที่คุณต้องการแบ่งปันอัตราค่าขนส่ง!',
  ShareWithMyself: 'คุณไม่จำเป็นต้องแบ่งปันอัตราค่าขนส่งให้กับบริษัทของคุณเอง!',
  ShippingClause: 'เงื่อนไขการขนส่ง',
  ShippingLine: 'รหัสท่าเรือนอก',
  ShippingSchedule: 'ตารางเรือ',
  Small: 'ย่อ',
  Source: 'แหล่งที่มาของอัตราค่าขนส่ง',
  SpecialPrice: 'ราคาพิเศษ',
  StartTime: 'เวลาเริ่มต้น',
  StatBeginDate: 'ช่วงเวลา',
  StatBeginDateByDate: 'ช่วงเวลาการบันทึก',
  StatBeginDateByPort: 'ช่วงเวลาที่มีผลบังคับใช้',
  StatEndDate: 'ถึง',
  StatSucceed: 'ดำเนินการสำเร็จ!',
  State: 'สถานะอัตราค่าขนส่ง',
  Statistics: 'สถิติ',
  SubContractNo: 'โค้ด',
  SubmittedBy: 'ผู้ส่ง',
  SubmittedDate: 'เวลาที่ส่ง',
  Subscribe: 'สมัครสมาชิก',
  SubscribeCondition: 'เงื่อนไขการสมัครสมาชิก',
  SubscribeFromTenant: 'ผู้สมัครสมาชิกอยู่ใน Tenant',
  SubscribePOD: 'สถานที่ขนถ่ายสินค้า',
  SubscribePOL: 'สถานที่เริ่มต้นการขนส่ง',
  SubscribeType: 'ประเภทการสมัครสมาชิก',
  Subscriber: 'ผู้สมัครสมาชิก',
  Sum: 'รวมค่าใช้จ่าย',
  SumAbnormal: 'พบความผิดปกติในค่าระวางรวม',
  Sun: 'วันอาทิตย์',
  Sunday: 'วันอาทิตย์',
  Surcharge: 'ค่าธรรมเนียมเพิ่มเติม',
  SurchargeLoadFailed: 'โหลดค่าธรรมเนียมเพิ่มเติมไม่สำเร็จ!',
  Suspend: 'หยุดให้บริการ',
  SuspendRate: 'ราคาที่มีพื้นหลังสีเทาหยุดให้บริการแล้ว!',
  SuspendSelection: 'ตั้งค่าราคาที่เลือกเป็นสถานะ {0}?',
  TSport: 'ท่าเรือกลางทาง',
  TaskStart: 'งานตรวจสอบถูกส่งไปที่ระบบหลังบ้านแล้ว โปรดตรวจสอบข้อมูลในแท็บที่เผยแพร่ในภายหลัง!',
  Template: 'ดาวน์โหลดเทมเพลต',
  TenantPrompt: 'กรุณาใส่ Tenant',
  Three_BE_One: 'ค่าระวางระดับ 3 ต้องไม่ต่ำกว่าระดับ 1!',
  Three_BE_Two: 'ค่าระวางระดับ 3 ต้องไม่ต่ำกว่าระดับ 2!',
  Three_B_One: 'ค่าระวางระดับ 3 ต้องสูงกว่าระดับ 1!',
  Thu: 'วันพฤหัสบดี',
  Thursday: 'วันพฤหัสบดี',
  Times: 'ครั้ง',
  Tips: 'แจ้งเตือน',
  TotalAmount: 'จำนวนรายการ',
  TradeLane: 'เส้นทางเดินเรือ',
  TransferPort: 'ท่าเรือกลางทาง',
  TransportMode: 'วิธีการขนส่ง',
  Tue: 'วันอังคาร',
  Tuesday: 'วันอังคาร',
  Two_BE_One: 'ค่าระวางระดับ 2 ต้องไม่ต่ำกว่าระดับ 1!',
  Two_B_One: 'ค่าระวางระดับ 2 ต้องสูงกว่าระดับ 1!',
  UnNo: 'UNNO',
  UnitPrice: 'ราคาต่อหน่วย',
  UploadFailed: 'อัปโหลดไม่สำเร็จ',
  UploadSucceed: 'อัปโหลดสำเร็จ',
  VALIDITY_ERROR: '{0} แถว {1} อนุญาตให้ป้อนค่าจัดส่งภายในสองเดือนถัดไปเท่านั้น \n',
  VALIDITY_LESS: 'แถว {0}"{1}"ต้องไม่น้อยกว่า"Valid fm";\n',
  VAT: 'อัตราภาษี',
  ValidAbnormal: 'พบความผิดปกติในระยะเวลาที่มีผลของค่าระวาง',
  Validation: 'ความถูกต้อง',
  ValidityCfgLoadError: 'ดาวน์โหลดข้อมูลการตรวจสอบความถูกต้องของค่าระวางไม่สำเร็จ!',
  VatIncluded: 'รวมภาษี',
  VatInvalid: 'อัตราภาษีราคาขายต้องไม่น้อยกว่าอัตราภาษีต้นทุน',
  Via: 'ท่าเรือกลางทาง',
  View: 'ดู',
  Visible: 'มองเห็นได้',
  Volume: 'ปริมาตร',
  VolumeCost: 'ต้นทุนราคาตามปริมาตร',
  VolumePrice: 'ราคาตามปริมาตร',
  WYSIWYG: 'เห็นอะไรได้อย่างนั้น',
  WantApply: 'ชื่อผู้ขออัตราค่าขนส่ง',
  Warning: 'คำเตือน',
  Wed: 'วันพุธ',
  Wednesday: 'วันพุธ',
  Week: 'สัปดาห์นี้',
  Weight: 'น้ำหนัก (กก.)',
  WeightCost: 'ต้นทุนราคาตามน้ำหนัก',
  WeightLimitInfo: 'ข้อมูลจำกัดน้ำหนัก',
  WeightLimitLoadFailed: 'โหลดข้อมูลจำกัดน้ำหนักล้มเหลว!',
  WeightPrice: 'ราคาตามน้ำหนัก',
  WeightRule: 'กฎเกณฑ์จำกัดน้ำหนัก',
  Weight_LCL: 'น้ำหนัก',
  Wrong: 'ไม่ถูกต้อง!',
  WrongInput: 'ป้อนข้อมูลผิดพลาด!',
  EtaMustBeLaterThanOrEqualToEtd: 'ETA ต้องหลังหรือเท่ากับ ETD',
  Yes: 'ใช่',
  YesLabel: 'ดู',
  amsEns: 'AMS/ENS',
  inviteTime: 'วันที่เชิญ',
  jobTypeExport: 'ส่งออก',
  jobTypeImport: 'นำเข้า',
  overloadRemarks: 'คำอธิบายน้ำหนักเกิน',
  quantity: 'จำนวนชิ้น',
  resetDataGrid: 'รีเซตตาราง',
  selectedCount: 'ปัจจุบันเลือกไว้ {0} รายการ',
  AcceptTenant2: 'ผู้สมัครสมาชิก',
  AcceptUser2: 'ผู้ดำเนินการสมัครสมาชิก',
  AcceptTime2: 'วันที่เริ่มใช้การแบ่งปันอัตราค่าขนส่ง',
  InviteTenant2: 'ผู้แบ่งปัน',
  InviteUser2: 'ผู้ดำเนินการแบ่งปัน',
  inviteTime2: 'วันที่เชิญ/ยื่นคำขอ',
  customSpecs: 'กำหนดเอง',
  reject: 'ปฏิเสธ',
  fclRateSearch: 'ค้นหาอัตราค่าขนส่งแบบเต็มตู้',
  onlyViewAndEditCostAreAllow: 'อนุญาตให้ดูและแก้ไขอัตราค่าขนส่งต้นทุนเท่านั้น',
  SubscribePOLType: 'ประเภทจุดเริ่มต้น',
  DestinationType: 'ประเภทจุดหมายปลายทาง',
  Destination: 'จุดหมายปลายทาง',
  OtherCharge: 'ค่าบริการอื่นๆ',
  priceNoPrompt: 'กรุณาใส่หมายเลขอัตราค่าขนส่งหรือ 7 ตัวท้าย',
  polOrPodOrRegionOneMustBeEntered: 'ต้องกรอกท่าเรือต้นทาง ท่าเรือปลายทาง หรือเส้นทางใดเส้นทางหนึ่ง',
  costAndSumInvalidSave: 'ราคาขายน้อยกว่าต้นทุน \#n ยืนยันประหยัดหรือไม่',
  pleaseChooseOtherOfficeData: 'ไม่ได้เลือกข้อมูล หรือเลือกข้อมูลของสาขาอื่น',
  noSelectedPrice: 'ไม่ได้เลือกอัตราค่าขนส่ง',
  BelongingCity: 'เมืองที่ตั้ง',
  UpdateQuotationValidity: 'ต้องการอัปเดตวันหมดอายุของใบเสนอราคาตามอายุการใช้งานของอัตราค่าขนส่งหรือไม่?',
  CheckQuotationDeleteTip: 'ไม่อนุญาตให้ลบใบเสนอราคาที่มีการสร้างคำสั่งซื้อแล้ว!',
  PlsSelectAirOF: 'กรุณาเลือกข้อมูลอัตราค่าขนส่งหนึ่งรายการเป็นค่าขนส่งทางอากาศ',
  NotMatchChargeItem: 'ไม่พบชื่อค่าบริการที่ตรงกัน ({0}) กรุณาบำรุงรักษารหัสแพลตฟอร์ม【{1}】ในโมดูลรายการค่าบริการ!',
  AirFreight: 'ค่าขนส่งทางอากาศ',
  WarExpenses: 'ค่าสงคราม',
  FuelSurcharge: 'ค่าธรรมเนียมน้ำมันเชื้อเพลิง',
  WarehousingFee: 'ค่าขนเข้าคลัง',
  SeaFreight: 'ค่าขนส่งทางทะเล',
  QuotationWeightAndCubageLessZero: 'น้ำหนักและปริมาตรในใบเสนอราคาไม่สามารถน้อยกว่า 0 ได้!',
  Name: 'ชื่อ',
  MatchType: 'วิธีการจับคู่',
  PriceType: 'ประเภทอัตราค่าขนส่ง',
  priceNature: 'คุณสมบัติการส่งมอบ',
  TraditionalFreightRates: 'อัตราค่าขนส่งแบบออฟไลน์',
  Traditional: 'ออฟไลน์',
  ECommerce: 'อีคอมเมิร์ซ',
  SpotFreightRates: 'อัตราค่าขนส่งอีคอมเมิร์ซ',
  ConfigureTheSurcharge: 'กำหนดค่าธรรมเนียมเพิ่มเติม',
  ConfigureTheSurchargeTips: 'สามารถกำหนดค่าธรรมเนียมเพิ่มเติมที่ต้องการแสดงในรายการ',
  SpotContainerWeightTips: 'น้ำหนักคอนเทนเนอร์เริ่มต้นของอัตราค่าขนส่งอีคอมเมิร์ซ: 18,000 กิโลกรัม',
  TariffTableExportExcelTips: 'เนื่องจากปริมาณข้อมูล แนะนำให้เลือกอายุการใช้งานก่อน และช่วงเวลาควรไม่เกิน 3 เดือน',
  PolCountry: 'ประเทศท่าเรือต้นทาง',
  PolRegion: 'ภูมิภาคท่าเรือต้นทาง',
  PodCountry: 'ประเทศท่าเรือปลายทาง',
  PriceProfile: 'ข้อมูลกลยุทธ์',
  SharingProfile: 'แบ่งปันกลยุทธ์',
  SelectProfile: 'เลือกกลยุทธ์',
  ViewProfile: 'ดูกลยุทธ์',
  PodCity: 'เมืองท่าเรือปลายทาง',
  weightVolume: 'สัดส่วนสินค้า',
  DestinationAgent: 'ตัวแทนท่าเรือปลายทาง',
  warehouse: 'คลังสินค้า',
  WarehouseName: 'ชื่อคลังสินค้า',
  WarehouseAddress: 'ที่อยู่คลังสินค้า',
  WarehouseMap: 'แผนที่คลังสินค้า',
  warehouseContact: 'ผู้ติดต่อคลังสินค้า',
  FlightInformationManagement: 'การจัดการข้อมูลเที่ยวบิน',
  FlightNo: 'หมายเลขเที่ยวบิน',
  ClosingTime: 'เวลาปิดรับคำสั่งซื้อ',
  DepartureTime: 'เวลาออกเดินทาง',
  ArrivalTime: 'เวลาถึง',
  SizeLimit: 'ข้อจำกัดขนาด',
  SingletonWeightLimit: 'ข้อจำกัดน้ำหนักต่อชิ้น',
  ChemicalPkggReq: 'ความต้องการบรรจุภัณฑ์สารเคมี',
  LithiumBatteryReq: 'ความต้องการแบตเตอรี่ลิเธียม',
  TimeWarning: 'เวลาถึงต้องมากกว่าเวลาออกเดินทาง',
  AirDay: 'จำนวนวัน',
  flightNumber: 'หมายเลขเที่ยวบินไม่สามารถเว้นว่างได้',
  emptyTime: 'นี่คือเวลาท้องถิ่น',
  BatchImportQuotations: 'นำเข้าใบเสนอราคาแบบกลุ่ม',
  XSuccessfulXFailed: 'สำเร็จ【{0}】รายการ ล้มเหลว【{1}】รายการ!',
  ErrorVolumeWeightRatio: 'ป้อนอัตราส่วนน้ำหนักต่อปริมาตรผิดพลาด!',
  AirPriceServiceItem: 'นำเข้าล้มเหลว ไม่มีข้อมูลในบริการค่าขนส่งทางอากาศ กรุณาบำรุงรักษาข้อมูลก่อน',
  HsCode: 'รหัส HS'
}

